export default __webpack_public_path__ + "static/media/sb-icon-active.eab46507.svg";